import { NeuFeedback } from '@neutron/react';
import { GridContainer, GridRow, GridColumn } from '../grid/Grid';
import useApiFeedback from '../../shared/hooks/useApiFeedback';
import './Loader.scss';

function Loader (props: {kind?: 'spinner' | 'brand' | undefined, className?: string, size?: 'small' | 'default' | 'large' | undefined, loaderColor?: "blue" | "orange" | undefined }) {
  const { pendingRequests, errorMessage } = useApiFeedback();

  return (
    <GridContainer className={`loader text-center${ props.className?? ''}${pendingRequests === 0 && errorMessage ? ' d-none' : ''}`}>
      <GridRow>
        <GridColumn columns={12}>
          <NeuFeedback kind={props.kind ? props.kind : 'brand'} size={props.size ? props.size : 'default'} color="blue" label="" text=""></NeuFeedback>
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

export default Loader;
